export interface ApiErrorShape {
  error: {
    code: string
    message: string
    field?: string
    requestId: string
  }
}

export class ApiError extends Error {
  code: string
  requestId?: string

  constructor(message: string, code = 'REQUEST_FAILED', requestId?: string) {
    super(message)
    this.name = 'ApiError'
    this.code = code
    this.requestId = requestId
  }
}

function cookie(name: string) {
  return document.cookie
    .split('; ')
    .find((item) => item.startsWith(`${name}=`))
    ?.split('=')
    .slice(1)
    .join('=')
}

export async function api<T>(path: string, init: RequestInit = {}): Promise<T> {
  const headers = new Headers(init.headers)
  if (init.body && !headers.has('Content-Type')) headers.set('Content-Type', 'application/json')
  const method = (init.method ?? 'GET').toUpperCase()
  if (!['GET', 'HEAD', 'OPTIONS'].includes(method)) {
    const csrf = cookie('ilovesing_csrf')
    if (csrf) headers.set('X-CSRF-Token', decodeURIComponent(csrf))
  }

  let response: Response
  try {
    response = await fetch(path, { ...init, headers, credentials: 'same-origin' })
  } catch {
    throw new ApiError('目前無法連線，請確認本機 API 已啟動', 'NETWORK_ERROR')
  }

  if (response.status === 204) return undefined as T
  const payload = (await response.json().catch(() => null)) as { data?: T } | ApiErrorShape | null
  if (!response.ok) {
    const error = payload && 'error' in payload ? payload.error : null
    throw new ApiError(error?.message ?? '請求失敗', error?.code, error?.requestId)
  }
  if (!payload || !('data' in payload)) throw new ApiError('伺服器回應格式不正確')
  return payload.data as T
}

